import moment from "moment"
import TapaModel from "../models/TapaForm"

const today: Date = new Date();
const TAPA_SCHEMA: TapaModel = {
    id: -1,
    create_date: '',
    truck_number: '',
    origin: '',
    id_gha: -1,
    carrier: '',
    driver_name: '',
    tractor_license: '',
    trailer_license: '',
    trailer_number: '',
    seal_arrival: '',
    user_id_seal_arrival: -1,
    user_arrival_seal_date: '',
    seal_departure: '',
    user_id_seal_departure: -1,
    user_departure_seal_date: '',
    inspection_completed: false,
    id_user_inspection: -1,
    inspection_date: '',
    seal_checked: false,
    id_user_seal_check: -1,
    seal_check_date: '',
    undercarriage_check: false,
    id_user_undercarriage_check: -1,
    undercarriage_check_date: '',
    inside_doors_check: false,
    id_user_inside_doors_check: -1,
    inside_doors_check_date: '',
    right_side_check: false,
    id_user_right_side_check: -1,
    right_side_check_date: '',
    left_side_check: false,
    id_user_left_side_check: -1,
    left_side_check_date: '',
    front_wall_check: false,
    id_user_front_wall_check: -1,
    front_wall_check_date: '',
    roof_check: false,
    id_user_roof_check: -1,
    roof_check_date: '',
    floor_check: false,
    id_user_floor_check: -1,
    floor_check_date: '',
    remarks: '',
    orders: [],
    follow_up_date: moment(today).format("YYYYMMDD"),
    follow_up_time: moment(today).format("HH:mm"),
    follow_up_name: ''
}

export { TAPA_SCHEMA }